var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon "
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.15,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#075056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.3982 15.8242L7.13647 12.582C7.04533 12.4909 6.99976 12.3737 6.99976 12.2305C6.99976 12.0872 7.04533 11.97 7.13647 11.8789L7.85913 11.1758C7.95027 11.0716 8.06421 11.0195 8.20092 11.0195C8.33764 11.0195 8.45809 11.0716 8.56225 11.1758L10.7497 13.3633L15.4372 8.67578C15.5414 8.57161 15.6618 8.51953 15.7986 8.51953C15.9353 8.51953 16.0492 8.57161 16.1404 8.67578L16.863 9.3789C16.9542 9.47005 16.9997 9.58724 16.9997 9.73047C16.9997 9.87369 16.9542 9.99088 16.863 10.082L11.1013 15.8242C11.0102 15.9284 10.893 15.9805 10.7497 15.9805C10.6065 15.9805 10.4893 15.9284 10.3982 15.8242Z",
    fill: "#075056"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.afda7eeb01a6de2c496a8b62466991d3.svg";
export { ForwardRef as ReactComponent };